import { useState } from "react";
import { ChecklistEditor, type CheckItem } from "./ChecklistAttachments";

export function PresetStepsField({ value, type, onChange }: { value: string[]; type: string; onChange: (items: string[]) => void }) {
  const [items, setItems] = useState<CheckItem[]>(() => (value || []).map((t) => ({ id: crypto.randomUUID(), text: t })));
  const update = (next: CheckItem[]) => { setItems(next); onChange(next.map((i) => i.text)); };
  return (
    <div className="rounded-md border border-gray-200 bg-gray-50/60 p-3" data-testid="wo-presets-steps-builder">
      <ChecklistEditor items={items} onChange={update} type={type || "any"} compact />
      <div className="mt-2 text-[11px] text-gray-500">{items.length} step{items.length === 1 ? "" : "s"}. Use “Add saved step…” to reuse a step from the library, or the bookmark icon to save a step for other checklists.</div>
    </div>
  );
}
